<div class="card">
    <grid #grid [tableSettings]="tableSettings" [gridSettings]="gridSettings"></grid>
</div>
<div class="buttons-panel">
    <p-button type="button" label="Check" (onClick)="check()"></p-button>
</div>